import { createSlice } from "@reduxjs/toolkit";
import { fetchJobDetails } from "./fetchJobDetailsSlice";

const hasValuesSlice = createSlice({
  name: "hasValues",
  initialState: { 0: { zone: 1 }, 1: { zone: 2 } },
  reducers: {
    updateHasValues: (state, action) => {
      const items = Array.isArray(action.payload) ? action.payload : [];
      items.forEach((item) => {
        const zone = item.zone || 1; // Ensure zone is defined and default to 1
        const hasValues = {};
        for (const [key, value] of Object.entries(item)) {
          if (key.startsWith("Has") && key !== "HasTBD") {
            // console.log("key:", key, "value:", value); // Log the key and value
            hasValues[key] = value;
          }
        }
        const zoneIndex = zone === 1 ? 0 : 1;
        if (!state[zoneIndex]) {
          state[zoneIndex] = { zone };
        }
        state[zoneIndex] = { ...state[zoneIndex], ...hasValues };
      });
      // console.log("Updated hasValues state:", JSON.parse(JSON.stringify(state))); // Log the hasValues state
    },
    clearHasValues: (state) => {
      return { 0: { zone: 1 }, 1: { zone: 2 } };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJobDetails.fulfilled, (state, action) => {
      const tableIds = action.payload;
      for (const items of Object.values(tableIds)) {
        items.forEach((item) => {
          const zone = item.zone || 1; // Ensure zone is defined and default to 1
          const hasValues = {};
          for (const [key, value] of Object.entries(item)) {
            if (key.startsWith("Has") && key !== "HasTBD") {
              // console.log("key:", key, "value:", value); // Log the key and value
              hasValues[key] = value;
            }
          }
          const zoneIndex = zone === 1 ? 0 : 1;
          if (!state[zoneIndex]) {
            state[zoneIndex] = { zone };
          }
          state[zoneIndex] = { ...state[zoneIndex], ...hasValues };
        });
      }
      // console.log("Updated hasValues state:", JSON.parse(JSON.stringify(state))); // Log the hasValues state
    });
  },
});

export const { updateHasValues, clearHasValues } = hasValuesSlice.actions;
export default hasValuesSlice.reducer;
